import React, { useEffect, useMemo, useState } from 'react';
import { useAutocomplete } from '@mui/base/AutocompleteUnstyled';
import { styled } from '@mui/system';
import { Form } from 'react-bootstrap';
import { debounce } from 'lodash';

const Listbox = styled('ul')(({ theme }) => ({
  width: 175,
  margin: 0,
  padding: '2px',
  zIndex: 1,
  position: 'absolute',
  listStyle: 'none',
  backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#000',
  overflow: 'auto',
  maxHeight: 200,
  border: '1px solid rgba(0,0,0,.25)',
  '& li.Mui-focused': {
    backgroundColor: '#f2006c',
    color: 'white',
    cursor: 'pointer',
  },
  '& li:active': {
    backgroundColor: '#2977f5',
    color: 'white',
  },
  '& li': {
    padding: '3px',
    fontSize: '1rem',
  },
}));

const CustomAutocomplete = (props) => {
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    inputValue,
  } = useAutocomplete({
    id: props.controlId,
    options: props.options,
    getOptionLabel: props.getOptionLabel,
    multiple: props.multiple
  });

  const rootProps = getRootProps();

  useEffect(() => {
    if (inputValue && inputValue != '' && inputValue != value) {
      const selectedOption = props.options.find(
        (data) => props.getOptionLabel(data) === inputValue,
      );
      props.handleOnChange(inputValue, selectedOption);
    }

    return () => {
      debouncedResults.cancel();
    };
  }, [inputValue]);

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  const [value, setValue] = useState(props.value || '');

  const debouncedResults = useMemo(() => debounce(props.handleSearch, 500), [props.handleSearch]);

  return (
    <>
      <Form.Group className={props.className} {...rootProps}>
        {
          props.label && (
            <Form.Label {...getInputLabelProps()}>{props.label}</Form.Label>
          )
        }
        <Form.Control
          className={props?.controlClassName}
          {...getInputProps()}
          placeholder={props.placeholder}
          name={props.name}
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            debouncedResults(event.target.value, true);
          }}
        />

        {groupedOptions.length > 0 && (
          <Listbox {...getListboxProps()}>
            {groupedOptions.map((option, index) => {
              const optionProps = getOptionProps({ option, index });
              return (
                <li
                  {...optionProps}
                  onClick={(event) => {
                    optionProps.onClick(event);
                    props.handleOnChange(props.getOptionLabel(option), option);
                  }}
                >
                  {props.getOptionLabel(option)}
                </li>
              );
            })}
          </Listbox>
        )}
      </Form.Group>
    </>
  );
};

export default CustomAutocomplete;
